<template>
  <span class="btn btn-sm" type="button" @click="toggleViewed()">
    <span v-if="waitingForResponse" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <span v-else-if="filmViewed" class="fa fa-check" aria-hidden="true"></span>
  </span>
</template>


<script>
import axios from "axios";
import { userStore } from "@/userStore";
import { EventBus } from "@/eventBus";
import analytics from "@/analytics";

export default {
  name: "FilmCheckbox",
  props: ['film_id'],
  data() {
    return {
      filmViewed: false,
      waitingForResponse: false,
      userStore,
      checkSound: null,
    }
  },
  created() {
    this.updateFilmViewed();
    EventBus.on('viewed-state-updated', (_film_id) => {
      if (this.film_id === _film_id) {
        this.updateFilmViewed();
      }
    });
    if ( this.$screenshotMode && this.$screenshotModeSettings.playCheckboxSound ) {
      this.checkSound = new Audio(this.$imagePathBase + 'audio/click_3.wav');
    }
  },
  methods: {
    updateFilmViewed() {
      this.filmViewed = userStore.isFilmMarkedViewed(this.film_id);
    },

    async toggleViewed() {

      if ( this.waitingForResponse ) {
        return;
      }

      this.waitingForResponse = true;
      axios.post(`/api/user/viewed/${this.film_id}/${!this.filmViewed}`)
          .then((response) => {
            // If, for some reason, we're trying to mark a film as viewed or unviewed,
            //  that already IS marked that way, we return a 204 (no content).
            if ( response.status === 200 ) {
              userStore.setUser(response.data);
              this.updateFilmViewed();
              EventBus.emit('viewed-state-updated', this.film_id);

              if ( this.filmViewed && this.checkSound ) {
                this.checkSound.play();
              }
              this.waitingForResponse = false;
              return this.filmViewed? axios.get(`/api/achievements/${this.film_id}`) : null
            }
          })
          .then((response) => {
            const achievements = response?.data;
            achievements?.forEach((achievement) => {
              if ( achievement.films.every(film => userStore.isFilmMarkedViewed(film)) ) {
                EventBus.emit('achievement-notification', {
                  achievementType: 'CATEGORY_COMPLETE',
                  category: achievement.category,
                  normalized_category: achievement.normalized_category,
                  ceremony: achievement.ceremony,
                  numFilmsViewed: achievement.films.length
                });
                analytics.sendAchievement("Category Complete", {
                  ceremony: achievement.ceremony,
                  category: achievement.normalized_category
                });
              }
            });
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
          })
          .finally(() => {
            this.waitingForResponse = false;
          });
    }
  }
}
</script>


<style scoped>
.btn {

  --bs-btn-color: var(--bs-dark);
  --bs-btn-hover-bg: var(--bs-dark);
  --bs-btn-hover-border-color: var(--bs-dark);
  --bs-btn-active-bg: var(--bs-dark);
  --bs-btn-border-color: var(--bs-dark);

  margin-bottom: -2px;
  height: 17px !important;
  width: 16px !important;
  .fa-check {
    position: absolute;
    margin-top: -3px;
    margin-left: -7px;
    color: var(--bs-tertiary-color);
  }
  .spinner-border {
    /*opacity: 30%;*/
    position: absolute;
    height: 10px !important;
    width: 10px !important;
    margin-top: -1px;
    margin-left: -5px;
  }
}

.btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
}


[data-bs-theme="dark"] .btn {
  /* Dark mode style (behaves like btn-outline-light) */
  --bs-btn-color: var(--bs-light);
  --bs-btn-border-color: var(--bs-light);
  --bs-btn-hover-bg: var(--bs-light);
  --bs-btn-hover-border-color: var(--bs-light);
  --bs-btn-active-bg: var(--bs-light);
  --bs-btn-active-color: var(--bs-dark);
}


/* the border color of checked boxes uses the bs-secondary-color, which adjusts itself for dark mode */
.btn:has(.fa-check) {
  --bs-btn-border-color: var(--bs-tertiary-color);
}

</style>